"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Definitions = void 0;
const index_1 = require("./Base/index");
/**
 * Contains the parsed ProcessModels, taken from a BPMN file.
 * This is the root object for the internal ProcessModel structure.
 */
class Definitions extends index_1.BaseElement {
    constructor() {
        super(...arguments);
        /**
         * Contains a list of all processes contained within this definition.
         */
        this.processes = [];
    }
    /**
     * Gets a list of all StartEvents contained in this ProcessDefinition.
     */
    getAllStartEvents() {
        const startEvents = [];
        for (const process of this.processes) {
            const startEventsForProcess = process.getStartEvents();
            startEvents.push(...startEventsForProcess);
        }
        return startEvents;
    }
    /**
     * Gets a list of all EndEvents contained in this ProcessDefinition.
     */
    getAllEndEvents() {
        const endEvents = [];
        for (const process of this.processes) {
            const endEventsForProcess = process.getEndEvents();
            endEvents.push(...endEventsForProcess);
        }
        return endEvents;
    }
    /**
     * Returns all FlowNodes that match the given type.
     */
    getFlowNodesByType(bpmnType) {
        const flowNodes = [];
        for (const process of this.processes) {
            const flowNodesForProcess = process.getFlowNodesByType(bpmnType);
            flowNodes.push(...flowNodesForProcess);
        }
        return flowNodes;
    }
}
exports.Definitions = Definitions;
//# sourceMappingURL=Definitions.js.map